import "./utils/vh";

import initMobileMenu from './components/mobileMenu';
import initScrollHeader from './components/scrollHeader';
import initIllustrations from './components/illustrations';
import initSmoothPage from './components/smoothPage';
import initPopups from './components/popups';
import initMarquee from './components/marque';
import initSwiper from './components/swiper';
import initColsParallax from './components/colsParallax';
import initFooterGridCircles from './components/footerGridCircles';
import initFixedFooterSection from './components/fixedFooterSection';
import initFixedFirstSection from './components/fixedFirstSection';
import initNextSection from './components/nextSection';
import initScrollCounter from './components/scrollCounter';
import initPreloader from './components/preloader';
import initCursor from './components/cursor';
import initBlockInView from './components/blockInView';
import initFormPlaceholder from './components/formPlaceholder';

window.addEventListener("DOMContentLoaded", function () {
  document.body.classList.add('is-loading');
  initMobileMenu();
  initIllustrations();
  initNextSection();
  initScrollHeader();
  initSmoothPage();
  initPopups();
  initMarquee();
  initSwiper();
  initColsParallax();
  initFooterGridCircles();
  initFixedFooterSection();
  initFixedFirstSection();
  initScrollCounter();
  initCursor();
  initBlockInView();
  initFormPlaceholder();
})
// njkmrj lk
window.addEventListener('load', () => {
  initPreloader();
})